import React from "react";
import styled from "@emotion/styled";
import * as bp from "@ecologi/react-components/src/theme/ecologi-breakpoints";
import { Spinner as SpinnerBase } from "../../Spinner";
import { renderToStaticMarkup } from "react-dom/server";
import { css } from "@emotion/react";

export const SpinnerIcon = styled(SpinnerBase)`
  fill: ${({ theme }) => theme.colors.forest};
`;

export const LoadingSpinner = styled.div`
  width: 100%;
  text-align: center;
`;

const DownArrowComponent = () => {
  return (
    <svg width="14" height="8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1l6 6 6-6"
        stroke="#222"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const UpArrowComponent = () => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L7 1L1 7"
        stroke="#222222"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const CheckComponent = () => {
  return (
    <svg width="20" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.707 6.293A1 1 0 00.293 7.707l1.414-1.414zM7 13l-.707.707a1 1 0 001.414 0L7 13zM19.707 1.707A1 1 0 0018.293.293l1.414 1.414zm-19.414 6l6 6 1.414-1.414-6-6L.293 7.707zm7.414 6l12-12L18.293.293l-12 12 1.414 1.414z"
        fill="#222222"
      />
    </svg>
  );
};
export const DownArrow = encodeURIComponent(
  renderToStaticMarkup(<DownArrowComponent />)
);
export const UpArrow = encodeURIComponent(
  renderToStaticMarkup(<UpArrowComponent />)
);
export const CheckMark = encodeURIComponent(
  renderToStaticMarkup(<CheckComponent />)
);

export const Wrapper = styled.div<{
  inputBg?: string;
}>`
  padding-top: 0px;
  .form-columns-1 {
    max-width: 100%;
  }
  fieldset {
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-block-start: 0;
    padding-inline-start: 0;
    padding-inline-end: 0;
    padding-block-end: 0;
  }
  .form-columns-2 {
    max-width: 100%;
    > div:first-of-type {
      padding-right: 36px;

      @media ${bp.desktopDown} {
        border-right: 0;
        padding-right: 0px;
      }
    }
    > div:last-of-type {
      padding-left: 36px;
      @media ${bp.desktopDown} {
        padding-left: 0px;
        border-left: 0;
        padding-right: 0px;
        margin-left: 0;
      }
    }
    div.input {
      margin-right: 0 !important;
    }
  }
  .hs-error-msg {
    color: red;
  }
  .field {
    padding-bottom: 16px;

    @media ${bp.desktopDown} {
      width: 100% !important;
    }
  }
  input {
    position: relative;
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 18px;
    padding: 10px 16px 9px 16px;
    border-left: none;
    border-right: none;
    border-top: 2px solid transparent;
    border-bottom: 2px solid #848a90;
    cursor: text;
    background-color: ${(props) => (props.inputBg ? props.inputBg : "#f2f2f2")};
    min-height: 48px;
    max-height: 127px;
    resize: vertical;
    margin-top: 10px;
    margin-bottom: 10px;
    @media ${bp.desktopDown} {
      width: 100% !important;
    }
  }

  input[type="checkbox"] {
    box-sizing: border-box;
    width: 24px !important;
    height: 24px !important;
    background: #ffffff;
    border-style: solid;
    border-color: #9fa6ad;
    border-width: 1px;
    outline: none;
    display: inline;
    min-height: auto;
    margin-top: 0px;
    margin-bottom: 0px;
    border-radius: 0;
    :hover {
      cursor: pointer;
    }
    :focus {
      outline: 2px solid #23a971;
    }
    accent-color: #23a971;
  }
  .hs-form-booleancheckbox-display {
    display: block;
    position: relative;
    padding-left: 0px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .hs-fieldtype-select .input {
    position: relative;
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    ::after {
      content: "";
      width: 18px;
      height: 14px;
      position: absolute;
      right: 14px;
      top: 19px;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .actions {
    text-align: center;
  }
  /* main lead gen form specific styles */
  .main-leadgen-form {
    .hs-form-checkbox {
      padding: 7px 0;
      :first-of-type {
        padding-top: 0;
        margin-top: -6px;
      }
      :last-child {
        padding-bottom: 0;
      }
    }
    .hs-interests {
      margin-bottom: 30px;
    }
    input {
      background-color: ${(props) =>
        props.inputBg ? props.inputBg : "#FFFFFF"};
    }
    .select-selected {
      background-color: #ffffff;
    }
    .inputs-list.multi-container {
      margin-bottom: 5px;
    }
  }
  /* / main lead gen form specific styles end */
  input[type~="submit"] {
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: -webkit-inline-flex;
    display: -moz-inline-box;
    display: inline-flex;
    font-family: "Sofia Pro", "Helvetica", "Arial", sans-serif;
    font-size: 18px;
    font-weight: bold;
    padding: 10px 24px;
    min-height: 48px;
    position: relative;
    text-decoration: none;
    z-index: 1;
    -webkit-align-items: center;
    -moz-box-align: center;
    align-items: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    justify-content: center;
    width: auto;
    margin-top: 40px;
    ${({ theme }) =>
      css`
        background: ${theme.colors.scarlet};
      `}
  }
  label {
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 20px;
  }
  .form-spacer {
    border-right: solid 4px #e2dad1;
    display: none;
  }
  .legal-consent-container ul.inputs-list {
    padding-inline-start: 0 !important;
    padding-left: 0 !important;
    li {
      label {
        display: block;
        font-weight: 500;
        span {
          margin-left: 35px;
          margin-top: 0;
        }
      }
    }
  }
  ul.inputs-list {
    padding-inline-start: 0 !important;
    padding-left: 0 !important;
    li {
      label {
        display: flex;
        align-items: center;
        font-weight: 500;
        span {
          margin-left: 10px;
        }
      }
    }
  }
  a {
    color: rgba(3, 95, 72, 1);
  }
  .hs-fieldtype-booleancheckbox.field {
    margin: 0;
    padding: 0px;
    label {
      padding: 3px 0;
    }
  }
  .legal-consent-container {
    p {
      padding: 5px 0;
    }
  }
  .hs-spacer {
    visibility: hidden;

    @media ${bp.desktopDown} {
      display: none;
    }
  }

  .hs-fieldtype-select {
    position: relative;
  }

  .hs-fieldtype-select select {
    display: none;
  }

  .select-selected {
    background-color: ${(props) =>
      props.inputBg ? props.inputBg : "#f2f2f2"}!important;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    padding: 0px 18px;
    height: 48px;
    white-space: nowrap;
    border-left: none;
    border-right: none;
    border-top: 2px solid transparent;
    border-bottom: 2px solid #848a90;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .select-selected:after {
    position: absolute;
    content: "";
    top: 18px;
    right: 15px;
    width: 14px;
    height: 8px;
    background-image: url("data:image/svg+xml;utf8, ${DownArrow}");
    background-size: contain;
    background-repeat: no-repeat;
  }

  .select-selected.select-arrow-active:after {
    background-image: url("data:image/svg+xml;utf8, ${UpArrow}");
  }

  .select-items div,
  .select-selected {
    cursor: pointer;
    color: #222222;
    padding: 9px 16px;
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0px;
  }

  .select-items {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 99;
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    outline: none;
    cursor: pointer;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    align-items: flex-start;
    border: 2px solid #222222;
    margin-left: 50px;
    margin-top: -11px;
    max-height: 300px;
    overflow-x: scroll;
    @media ${bp.desktopDown} {
      margin-left: 0px;
    }
  }

  .select-hide {
    display: none;
  }

  .select-items div,
  .same-as-selected {
    padding: 13px 19px;
  }
  .same-as-selected {
    background-color: #f2f2f2;
  }
  .select-items div:hover {
    background-color: #f5f5f5;
  }
  .same-as-selected:after {
    position: absolute;
    content: "";
    margin-top: 4px;
    right: 15px;
    width: 20px;
    height: 14px;
    background-image: url("data:image/svg+xml;utf8, ${CheckMark}");
    background-size: contain;
    background-repeat: no-repeat;
  }
  .hs_error_rollup .hs-error-msgs {
    .hs-main-font-element {
      display: none;
      color: red;
    }
  }
  span.hs-form-required {
    display: none;
  }
  .hs-input.invalid.error {
    border: solid 2px #f73a54;
  }
`;
